/**
 * @generated SignedSource<<c00046044d4be1b6d9dcf91d60855b56>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespUnavailableContextProvider_item$data = {
  readonly seller: {
    readonly isAccessible: boolean | null;
  } | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "PdpRespUnavailableContextProvider_item";
};
export type PdpRespUnavailableContextProvider_item$key = {
  readonly " $data"?: PdpRespUnavailableContextProvider_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespUnavailableContextProvider_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespUnavailableContextProvider_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAccessible",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "2fa57062bf423d8c372b8df2b73d87e3";

export default node;
